import { Component, OnInit, ElementRef, ChangeDetectorRef } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { CommonService } from '../../../shared/services/common.service'
import { ActivatedRoute, Router } from '@angular/router'
import { forkJoin, Observable } from 'rxjs'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { PLP_MENU_NAMES } from './plp-menu.model'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { BreadcrumbService } from '../../../shared/components/breadcrumb/breadcrumb.service'

@Component({
  standalone: false,
  selector: 'app-plp-menu-bar',
  templateUrl: './plp-menu-bar.component.html',
  styleUrls: ['./plp-menu-bar.component.scss'],
})
export class PlpMenuBarComponent implements OnInit {
  public apiurl = environment.occBaseUrl
  public deploypath = environment.deployPath
  categoryTypes$: Observable<any>

  plpMenu: any // = PRODUCTS_LISTING_PLP_MENU;
  plpMenuNames: any = PLP_MENU_NAMES
  plpMenusCustom: any

  childCategories: any = []
  cartId: string
  categoryObj: Object
  getCode: any
  loadInProgress: boolean = false
  categoryTypes: any

  response_MASONEILAN: any
  response_CONSOLIDATED: any
  response_BECKER: any
  response_MOONEY: any
  categoryId: any
  categoryName: any
  categoryData: any
  categoryDataResponse = []

  constructor(
    private commonService: CommonService,
    private router: Router,
    private activeCartService: ActiveCartFacade,
    private elRef: ElementRef,
    private activatedRoute: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private globalMessageService: GlobalMessageService,
    private breadcrumbService: BreadcrumbService
  ) {
    this.activeCartService.getActiveCartId().subscribe(
      (data) => {
        this.cartId = data
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  openProduct(evt, categoryId, categoryName, category, clicked) {
    if (
      categoryName !== undefined &&
      categoryId !== undefined &&
      !this.loadInProgress
    ) {
      this.categoryTypes = ''
      this.attachCategoryTypes(category)
      this.categoryId = categoryId
      this.categoryName = categoryName
      this.loadInProgress = true

      let i, tabcontent, tablinks

      tabcontent = this.elRef.nativeElement.querySelectorAll('.tabcontent')
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = 'none'
      }

      tablinks = this.elRef.nativeElement.querySelectorAll('.tablinks')
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(' active', '')
      }
      evt.currentTarget.className += ' active'
      this.fetchMenuCategory(categoryName, clicked)
    }
    if (clicked) {
      this.commonService.closeMenu.next({
        profileMenu: false,
        miniCart: false,
        megaNavMenu: false,
        changeAccMenu: false,
      })
    }
  }

  goToPlpHomepage() {
    // this.closeMenu();
    this.breadcrumbService.setShowHideBreadcrumb(false)
    this.router.navigate(['categories', this.categoryId])
  }
  closeMenu() {
    this.commonService.setMenuActive(false)
  }
  ngOnInit(): void {
    // this.plpMenu = PRODUCTS_LISTING_PLP_MENU;

    const apiParam = ['vsCategories', 'undefined'] //, 'ECOM_LVL0_00000002'];
    const apiUrl = this.commonService.constructUrl(apiParam)
    this.commonService.getData_WithoutRetry(apiUrl).subscribe(
      (data) => {
        this.categoryData = data
        this.plpMenusCustom = {}
        if (
          data['childCategories'] !== undefined &&
          data['childCategories'] !== null
        ) {
          for (let i = 0; i < data['childCategories'].length; i++) {
            if (data['childCategories'][i].name !== undefined) {
              this.plpMenusCustom[
                data['childCategories'][i].name.toUpperCase()
              ] = data['childCategories'][i].code
            }
          }
        }

        this.plpMenu = this.plpMenusCustom
        this.fetchAllMenuContents()
        this.activatedRoute.params.subscribe((data) => {
          if (data['categoryId'] !== undefined) {
            this.categoryId = data['categoryId']
          } else {
            this.categoryId = this.categoryData[0]?.code
          }
        })
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  fetchAllMenuContents() {
    const menuIdList = Object.values(this.plpMenu)
    const requestslist = []
    this.loadInProgress = true
    this.categoryData?.childCategories?.forEach((category) => {
      const apiParam = ['vsCategories', category?.code.toString()]
      const apiUrl = this.commonService.constructUrl(apiParam)
      requestslist.push(this.commonService.getData_WithoutRetry(apiUrl))
    })

    forkJoin(requestslist).subscribe(
      (response) => {
        this.categoryDataResponse = response
        this.categoryTypes = this.categoryDataResponse[0]
        this.fetchMenuCategory(
          this.categoryData?.childCategories[0]?.name,
          false
        )

        //STOP THE LOADER
        this.loadInProgress = false
        this.cd.detectChanges()
      },
      (error) => {
        //STOP THE LOADER
        this.loadInProgress = false
        this.cd.detectChanges()

        this.globalMessageService.add(
          { key: 'plp.issueWhileLoading' },
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  attachCategoryTypes(categoryName) {
    this.categoryTypes = categoryName
    this.cd.detectChanges()
  }

  fetchMenuCategory(categoryName, clicked) {
    this.categoryDataResponse.forEach((element) => {
      if (categoryName === element?.name) {
        this.fetchChildCategories(
          categoryName,
          element?.childCategories,
          clicked
        )
      }
    })
    this.cd.detectChanges()
  }

  fetchChildCategories(categoryName, parentChildCategory, clicked) {
    this.childCategories = this.split(parentChildCategory, 4)
    this.loadInProgress = false
    if (clicked) {
      this.goToPlpHomepage()
    }
    this.cd.detectChanges()
  }

  closeMenuBarDiv() {
    this.commonService.passMessage('closemenubardiv')
  }

  split(array, cols) {
    const newArray = []
    for (let c = 0; c < cols; c++) {
      newArray.push([])
    }
    for (let i = 0; i < array.length; i++) {
      const mod = i % cols
      newArray[mod].push(array[i])
    }
    return newArray
  }
}
